// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
      suggestionMobileStyle: 'style2', // style1, style2
		//suggestionMode: 'test'
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {};


	// Click Search box Event
	// SearchInput.prototype.afterBindEvents = function() {
	// 	this.$element.on('click', function() {
	// 		jQ('html,body').removeClass('js-drawer-open js-drawer-open-left');
	// 	});
	// }

	// InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
	// 	if (isCloseSearchBox && jQ('.js-drawer-open').length > 0) {
	// 		jQ('html,body').addClass('js-drawer-open js-drawer-open-left');
	// 	}
	// }
})();
